import React from 'react'
import { NumberType } from '@api'
import PrettyNumber from '@ui/PrettyNumber'
import { IGroup } from './types'
import css from './statsBar.module.scss'
import { Tooltip2 } from '@blueprintjs/popover2'

interface IProps {
  stats: IGroup
}

export default function StatsBar({ stats }: IProps) {
  return (
    <div className={css.row}>
      {stats.columns.map((c, i) => (
        <div className={css.counter} key={`stat-${i}`}>
          <div>
            <Tooltip2
              content={stats.tooltip && <p style={{ maxWidth: 142 }}>{stats.tooltip[i]}</p>}
            >
              <>
                <PrettyNumber
                  value={stats.values[0][i]}
                  numberType={
                    stats.columnTypes[i] === 'decimal'
                      ? NumberType.NUMBER
                      : NumberType.ROUNDED_NUMBER
                  }
                />
                {stats.columnTypes[i] === 'percent' ? '%' : ''}
              </>
            </Tooltip2>
          </div>
          <div className={css.label}>{c}</div>
        </div>
      ))}
    </div>
  )
}
